/**
 * Converts text to a data-testid format
 * @param text - The text to convert (e.g., "General Information")
 * @param suffix - Optional suffix to append (e.g., "option", "button")
 * @returns Formatted data-testid string (e.g., "general-information-option")
 */
export const toTestId = (text: string, suffix?: string): string => {
    const formatted = text
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-') // Replace one or more spaces with single dash
        .replace(/[^a-z0-9-]/g, '') // Remove special characters except dashes
        .replace(/-+/g, '-') // Replace multiple consecutive dashes with single dash
        .replace(/^-|-$/g, ''); // Remove leading/trailing dashes

    return suffix ? `${formatted}-${suffix}` : formatted;
};
